<template>
    <administrative>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="branches" :action="{'text':'add branch','url':route('administrative.branch.create')}" :searchlink="route('administrative.branch.search')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Branch')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Branch')">
                <template #action="data">
                    <button-link :href="route('administrative.branch.edit',data.item.id)"
                                 v-if="hasRole('Edit Branch')">Edit</button-link>
                    <button-link :href="route('administrative.branch.admin.edit',data.item.id)"  class="mx-4"
                                 v-if="hasRole('View User')">Admins</button-link>
                    <button-link :href="route('administrative.branch.teacher.edit',data.item.id)"
                                 v-if="hasRole('View Faculty')">Faculties</button-link>
                    <button-link :href="route('administrative.staff.create',data.item.id)"
                                 v-if="hasRole('View Staff')"
                                 class="mx-4" >Staff</button-link>
                </template>
            </breeze-table>
        </div>
    </administrative>
</template>

<script>
    import Administrative from '@/Pages/Administrative/Administrative'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'
    import {hasAnyRole, hasRole} from "../../../../Utils/checkPermission";

    export default {
        methods: {hasAnyRole, hasRole},
        components: {
            Administrative,
            BreezeTable,
            ButtonLink
        },
        props:['branches'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'code','label':'Code'},{'key':'city','label':'City'},{'key':'mobile','label':'Mobile'},{'key':'email','label':'Email'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
